import { bridgeApi } from '@/components/cloudFunctions/bridge'
import { withBridgeTransportRetry, type BridgeTransportRetryOptions } from './bridgeCallableRetry'

function wrapBridgeCallable<TArgs extends unknown[], TResult>(
  fn: (...args: TArgs) => Promise<TResult>,
): (...args: TArgs) => Promise<TResult> {
  return (...args: TArgs) => withBridgeTransportRetry(() => fn(...args))
}

export const bridgeCallables = {
  ensureBridgePatient: (options?: BridgeTransportRetryOptions) =>
    withBridgeTransportRetry(() => bridgeApi.ensureBridgePatient({}), options),
  createBridgePolicy: bridgeApi.createBridgePolicy,
  resolveBridgePolicyStatus: (
    data: Parameters<typeof bridgeApi.resolveBridgePolicyStatus>[0],
    options?: BridgeTransportRetryOptions,
  ) => withBridgeTransportRetry(() => bridgeApi.resolveBridgePolicyStatus(data), options),
  revalidateBridgePolicy: wrapBridgeCallable(bridgeApi.revalidateBridgePolicy),
  createBridgeServiceEligibility: wrapBridgeCallable(bridgeApi.createBridgeServiceEligibility),
  resolveBridgeServiceEligibilityStatus: wrapBridgeCallable(
    bridgeApi.resolveBridgeServiceEligibilityStatus,
  ),
  listBookableProviderEligibility: wrapBridgeCallable(bridgeApi.listBookableProviderEligibility),
}

export type BridgeCallables = typeof bridgeCallables
